export enum CampaignOMStatus {
  SCHEDULED = "SCHEDULED",
  CANCELLING = "CANCELLING",
  CANCELLED = "CANCELLED",
  RUNNING = "RUNNING",
  COMPLETE = "COMPLETE",
  COMPLETE_WITH_ERRORS = "COMPLETE_WITH_ERRORS",
  INCOMPLETE = "INCOMPLETE",
}
